export default __webpack_public_path__ + "static/Child_Protection_Policy-0f0c300b7a522c087166b9cc16c45616.pdf";